'use client';

import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { List } from '@jouzen/ecom-components/v3/List';
import { ListItem } from '@jouzen/ecom-components/v3/ListItem';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { TypographyRhythm } from '@jouzen/ecom-components/v3/TypographyRhythm';

const Content = () => {
  return (
    <LayoutGrid>
      <div className="col-main">
        <TypographyRhythm>
          <Typography variant="h1" Element="h1">
            Accessibility Statement
          </Typography>

          <Typography>
            This is the Accessibility Statement (“<b>Statement</b>”) for the
            ŌURA online store. This Statement applies to the service:{' '}
            <BodyLink href="/">www.ouraring.com</BodyLink> (the “<b>Service</b>
            ”)
          </Typography>

          <Typography>
            ŌURA is committed to ensuring the accessibility of its online store
            in accordance with the Act on the Provision of Digital Services
            (306/2019) and the EU Accessibility Directive. Our goal is to
            provide a digital service that is accessible to all users, including
            people with various functional limitations.
          </Typography>

          <Typography variant="h4" Element="h2" className="font-normal">
            Accessibility Status of the Online Store
          </Typography>

          <Typography>
            At this time, the accessibility of the online store has not yet been
            assessed. However, an evaluation is currently in progress, and this
            Statement will be updated upon its completion.
          </Typography>

          <Typography>
            There may be accessibility deficiencies within the Service. We will
            provide detailed information about any identified issues and planned
            corrective actions after the accessibility assessment is finalized.
          </Typography>

          <Typography>
            The Statement will be updated no later than August 31, 2025.
          </Typography>

          <Typography variant="h4" Element="h2" className="font-normal">
            Noticed an Accessibility Issue in Our Digital Service? Send
            Feedback.
          </Typography>

          <Typography>
            If you notice an accessibility problem on the Service, you can send
            us feedback. We kindly ask you to first contact the service
            administrator:
          </Typography>

          <Typography>
            <BodyLink href="https://support.ouraring.com" color="inherit">
              Feedback channel
            </BodyLink>
          </Typography>

          <Typography>
            Please describe as precisely as possible which part of the site the
            issue concerns and what kind of problem you encountered. We will
            respond to your feedback within 14 days. You may also request
            inaccessible content in an accessible format.
          </Typography>

          <Typography>
            If you are not satisfied with the response you receive or do not
            receive a reply within the time limit required by the law (14 days),
            you can submit a complaint to the supervisory authority:
          </Typography>

          <Typography weight="bold">
            Finnish Transport and Communications Agency Traficom
          </Typography>

          <Typography className="mb-0">
            Accessibility and Digital Accessibility Supervision Unit
          </Typography>
          <List className="mt-0">
            <ListItem>
              <BodyLink
                href="https://www.saavutettavuusvaatimukset.fi"
                color="inherit"
              >
                www.saavutettavuusvaatimukset.fi
              </BodyLink>
            </ListItem>
            <ListItem>
              <BodyLink
                href="mailto:saavutettavuus@traficom.fi"
                color="inherit"
              >
                saavutettavuus@traficom.fi
              </BodyLink>
            </ListItem>
            <ListItem>Switchboard phone number: +358 29 534 5000</ListItem>
          </List>

          <Typography variant="h4" Element="h2" className="font-normal">
            Statement Preparation
          </Typography>

          <Typography>
            This Statement was prepared on 28 June 2025.
            <br />
            The Statement is based on a self-assessment by the service provider
            and will be updated once the accessibility evaluation has been
            completed.
          </Typography>
        </TypographyRhythm>
      </div>
    </LayoutGrid>
  );
};

export default Content;
